<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-安全培训-添加
    -->
    <el-dialog
    title="添加安全培训"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加安全培训</div>

      <el-form-item label="所属组织" prop="affiliated_organization">
        <el-select v-model="form.affiliated_organization" placeholder="请选择所属组织" class="max-w460">
          <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.ma_company_id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="计划名称" prop="plan_name">
        <el-input v-model="form.plan_name" placeholder="请输入计划名称" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="计划模式" prop="plan_mode">
        <el-select v-model="form.plan_mode" placeholder="请选择计划模式" class="max-w460">
          <el-option label="网络学习" value="1"></el-option>
          <el-option label="现场学习" value="2"></el-option>
          <el-option label="网络考试" value="3"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="开始时间" prop="start_time">
        <el-date-picker v-model="form.start_time" type="datetime" placeholder="请选择开始时间" class="max-w460"></el-date-picker>
      </el-form-item>

      <el-form-item label="结束时间" prop="end_time">
        <el-date-picker v-model="form.end_time" type="datetime" placeholder="请选择结束时间" class="max-w460"></el-date-picker>
      </el-form-item>

      <el-form-item label="适用岗位" prop="applicable_position">
        <el-table
          :data="departments"
          size="small"
          border
          style="width: 100%; margin-bottom: 10px;"
        >
          <el-table-column label="部门" width="250" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.ma_depart_id"
                placeholder="请选择部门"
                size="mini"
                clearable
                style="width: 100%;"
                @change="handleDepartmentSelect(scope.$index, $event)"
              >
                <el-option
                  v-for="dept in departmentList"
                  :key="dept.ma_depart_id"
                  :label="dept.name"
                  :value="dept.ma_depart_id"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="岗位" width="250" align="center">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.ma_position_id"
                placeholder="请选择岗位"
                size="mini"
                clearable
                style="width: 100%;"
                :disabled="!scope.row.ma_depart_id"
              >
                <el-option
                  v-for="position in getPositionOptions(scope.row.ma_depart_id)"
                  :key="position.ma_position_id"
                  :label="position.name"
                  :value="position.ma_position_id"
                />
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="是否主岗位" width="100" align="center">
            <template slot-scope="scope">
              <el-radio
                v-model="main_department_index"
                :label="scope.$index"
              ></el-radio>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="80" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                circle
                @click="removeDepartment(scope.$index)"
                :disabled="departments.length <= 1"
              />
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align: center; margin-bottom: 10px;">
          <el-button type="primary" size="small" @click="addDepartment">
            <i class="el-icon-plus"></i> 新增部门岗位
          </el-button>
        </div>
      </el-form-item>

      <el-form-item label="参加学员" prop="participants">
        <el-input v-model="participantsText" placeholder="请选择参加学员" class="max-w460" readonly @click="openParticipantsDialog">
          <el-button slot="append" icon="el-icon-search" @click="openParticipantsDialog">选择</el-button>
        </el-input>
      </el-form-item>

      <template v-if="form.plan_mode && form.plan_mode !== '3'">
        <el-form-item label="安全管理员" prop="safety_administrator">
          <el-input v-model="form.safety_administrator_name" placeholder="请选择安全管理员" class="max-w460" readonly @click="openSafetyAdministratorDialog">
            <el-button slot="append" icon="el-icon-search" @click="openSafetyAdministratorDialog">选择</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="考核人员" prop="examiner">
          <el-input v-model="form.examiner_text" placeholder="请选择考核人员" class="max-w460" readonly @click="openExaminerDialog">
            <el-button slot="append" icon="el-icon-search" @click="openExaminerDialog">选择</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="授课人" prop="instructor">
          <el-input v-model="form.instructor_text" placeholder="请选择授课人" class="max-w460" readonly @click="openInstructorDialog">
            <el-button slot="append" icon="el-icon-search" @click="openInstructorDialog">选择</el-button>
          </el-input>
        </el-form-item>

        <el-form-item label="学时" prop="study_hours">
          <el-input-number v-model="form.study_hours" :min="1" :max="100" placeholder="请输入学时" class="max-w460"></el-input-number>
        </el-form-item>

        <el-form-item label="课堂" prop="training_course">
          <el-input v-model="form.training_course_name" placeholder="请选择课堂" class="max-w460" readonly @click="openCoursewareDialog">
            <el-button slot="append" icon="el-icon-search" @click="openCoursewareDialog">选择</el-button>
          </el-input>
        </el-form-item>

        <!-- <el-form-item label="培训教室" prop="training_room">
          <el-input v-model="form.training_room_name" placeholder="请选择培训教室" class="max-w460" readonly @click="openClassroomDialog">
            <el-button slot="append" icon="el-icon-search" @click="openClassroomDialog">选择</el-button>
          </el-input>
        </el-form-item> -->

        <el-form-item label="上传文档" prop="documents">
          <div class="draggable-list">
            <div v-for="(item, index) in form.documents" :key="index" class="item">
              <div class="file-item">
                <i class="el-icon-document"></i>
                <span>{{ getFileName(item) }}</span>
                <div class="delete-btn" @click="deleteDocument(index)"><i class="el-icon-close"></i></div>
              </div>
            </div>
            <div class="item img-select" @click="openProductUpload('document')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="上传图片" prop="images">
          <div class="draggable-list">
            <div v-for="(item, index) in form.images" :key="index" class="item">
              <img :src="item" width="100" height="100" />
              <div class="delete-btn" @click="deleteImage(index)"><i class="el-icon-close"></i></div>
            </div>
            <div class="item img-select" @click="openProductUpload('image')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>
      </template>

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>



      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
     <!--业务附件上传组件-->
     <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传文件
    </Upload>

    <el-dialog title="选择参加学员" :visible.sync="participantsDialogVisible" width="70%" append-to-body>
      <div class="participants-dialog">
        <el-form :inline="true" :model="employeeSearchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="employeeSearchForm.phone" placeholder="请输入手机号" clearable style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchEmployees">查询</el-button>
            <el-button @click="resetEmployeeSearch">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="mb10">
          <el-checkbox v-model="selectAll" @change="handleSelectAll">全选</el-checkbox>
          <span class="ml10">已选择 {{ selectedParticipants.length }} 人</span>
        </div>

        <el-table
          ref="employeeTable"
          :data="employeeList"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名" width="120"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
          <el-table-column prop="gender" label="性别" width="80">
            <template slot-scope="scope">
              {{ scope.row.gender === 1 ? '男' : '女' }}
            </template>
          </el-table-column>
          <el-table-column prop="department_name" label="部门"></el-table-column>
          <el-table-column prop="position_name" label="岗位"></el-table-column>
        </el-table>

        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleEmployeeSizeChange"
            @current-change="handleEmployeeCurrentChange"
            :current-page="employeeCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="employeePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeTotal">
          </el-pagination>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="participantsDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmParticipants">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择课堂" :visible.sync="coursewareDialogVisible" width="70%" append-to-body>
      <div class="courseware-dialog">
        <el-form :inline="true" :model="coursewareSearchForm" size="small">
          <el-form-item label="课堂（课室）名称">
            <el-input v-model="coursewareSearchForm.search" placeholder="请输入课堂（课室）名称" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="组织名称">
            <el-select v-model="coursewareSearchForm.orgName" placeholder="请选择组织名称" clearable style="width: 200px;">
              <el-option v-for="item in companyList" :key="item.ma_company_id" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课堂状态">
            <el-select v-model="coursewareSearchForm.classStatus" placeholder="请选择课堂状态" clearable style="width: 150px;">
              <el-option label="正常" value="正常"></el-option>
              <el-option label="停用" value="停用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="适用范围">
            <el-input v-model="coursewareSearchForm.applicableScope" placeholder="请输入适用范围" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchCourseware">查询</el-button>
            <el-button @click="resetCoursewareSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="mb10" v-if="selectedCourseware">已选：{{ selectedCourseware.name }}</div>
        <el-table ref="coursewareTable" :data="coursewareList" border style="width: 100%" highlight-current-row @row-click="selectCourseware">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="orgName" label="组织名称" width="120">
            <template slot-scope="scope">{{ scope.row.orgName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="classPurpose" label="课堂用途" width="100"></el-table-column>
          <el-table-column prop="capacity" label="可容纳人数" width="100"></el-table-column>
          <el-table-column prop="classStatus" label="课堂状态" width="90"></el-table-column>
          <el-table-column prop="applicableScope" label="适用范围"></el-table-column>
        </el-table>

        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleCoursewareSizeChange"
            @current-change="handleCoursewareCurrentChange"
            :current-page="coursewareCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="coursewarePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="coursewareTotal">
          </el-pagination>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="coursewareDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmCourseware">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择安全管理员" :visible.sync="safetyAdministratorDialogVisible" width="70%" append-to-body>
      <div class="employee-dialog">
        <el-form :inline="true" :model="employeeSearchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchEmployees">查询</el-button>
            <el-button @click="resetEmployeeSearch">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          ref="safetyAdminTable"
          :data="employeeList"
          border
          style="width: 100%"
          @selection-change="handleSafetyAdministratorSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="department_name" label="部门"></el-table-column>
        </el-table>

        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleEmployeeSizeChange"
            @current-change="handleEmployeeCurrentChange"
            :current-page="employeeCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="employeePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeTotal">
          </el-pagination>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="safetyAdministratorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSafetyAdministrator">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择考核人员" :visible.sync="examinerDialogVisible" width="70%" append-to-body>
      <div class="employee-dialog">
        <el-form :inline="true" :model="employeeSearchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchEmployees">查询</el-button>
            <el-button @click="resetEmployeeSearch">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="employeeList"
          border
          style="width: 100%"
          @selection-change="handleExaminerSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="department_name" label="部门"></el-table-column>
        </el-table>

        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleEmployeeSizeChange"
            @current-change="handleEmployeeCurrentChange"
            :current-page="employeeCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="employeePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeTotal">
          </el-pagination>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="examinerDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExaminer">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="选择授课人" :visible.sync="instructorDialogVisible" width="70%" append-to-body>
      <div class="employee-dialog">
        <el-form :inline="true" :model="employeeSearchForm" size="small">
          <el-form-item label="姓名">
            <el-input v-model="employeeSearchForm.name" placeholder="请输入姓名" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchEmployees">查询</el-button>
            <el-button @click="resetEmployeeSearch">重置</el-button>
          </el-form-item>
        </el-form>

        <el-table
          :data="employeeList"
          border
          style="width: 100%"
          @selection-change="handleInstructorSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="phone" label="手机号"></el-table-column>
          <el-table-column prop="department_name" label="部门"></el-table-column>
        </el-table>

        <div class="mt20 text-center">
          <el-pagination
            @size-change="handleEmployeeSizeChange"
            @current-change="handleEmployeeCurrentChange"
            :current-page="employeeCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="employeePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="employeeTotal">
          </el-pagination>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="instructorDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmInstructor">确定</el-button>
      </div>
    </el-dialog>

    <!-- <el-dialog title="选择培训教室" :visible.sync="classroomDialogVisible" width="70%" append-to-body>
      <div class="classroom-dialog">
        <el-form :inline="true" :model="classroomSearchForm" size="small">
          <el-form-item label="教室名称">
            <el-input v-model="classroomSearchForm.name" placeholder="请输入教室名称" clearable style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchClassroom">查询</el-button>
            <el-button @click="resetClassroomSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="classroomList" border style="width: 100%" @row-click="selectClassroom" highlight-current-row>
          <el-table-column prop="name" label="教室名称"></el-table-column>
          <el-table-column prop="orgName" label="组织"></el-table-column>
          <el-table-column prop="capacity" label="容量"></el-table-column>
          <el-table-column prop="location" label="位置"></el-table-column>
        </el-table>
        <div class="mt20 text-center">
          <el-pagination @size-change="handleClassroomSizeChange" @current-change="handleClassroomCurrentChange"
            :current-page="classroomCurrentPage" :page-sizes="[10, 20, 50, 100]" :page-size="classroomPageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="classroomTotal"></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="classroomDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmClassroom">确定</el-button>
      </div>
    </el-dialog> -->
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>

</template>

<script>
import Ma_safety_trainingApi from '@/api/ma_safety training.js';
import Ma_companyApi from '@/api/ma_company.js';
import Ma_classrm_mgmtApi from '@/api/ma_classrm_mgmt.js';
// import CoursewareApi from '@/api/courseware.js';
import AfuncApi from '@/api/afunc.js';

import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
         /*是否上传图片*/
         isupload: false,
      isImg: false,
         /*富文本配置*/
         ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        affiliated_organization: '',
        plan_name: '',
        plan_mode: '',
        start_time: '',
        end_time: '',
        participants: [],
        participants_text: '',
        safety_administrator: '',
        safety_administrator_name: '',
        examiner: [],
        examiner_text: '',
        instructor: [],
        instructor_text: '',
        study_hours: 1,
        training_course: '',
        training_course_name: '',
        training_room: '',
        training_room_name: '',
        documents: [],
        images: [],
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        affiliated_organization: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        plan_name: [{ required: true, message: '请输入计划名称', trigger: 'blur' }],
        plan_mode: [{ required: true, message: '请选择计划模式', trigger: 'change' }],
        start_time: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        end_time: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        safety_administrator: [{ required: true, message: '请选择安全管理员', trigger: 'change' }],
        examiner: [{ required: true, message: '请选择考核人员', trigger: 'change' }],
        instructor: [{ required: true, message: '请选择授课人', trigger: 'change' }],
        study_hours: [{ required: true, message: '请输入学时', trigger: 'blur' }],
        training_course: [{ required: true, message: '请选择课堂', trigger: 'blur' }],
        // training_room: [{ required: true, message: '请输入培训教室', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      code:"album",
      companyList: [],
      departmentList: [],
      positionList: [],
      employeeList: [],
      classroomList: [],
      coursewareList: [],
      coursewareDialogVisible: false,
      coursewareSearchForm: {
        search: '',
        orgName: '',
        classStatus: '',
        applicableScope: ''
      },
      coursewareCurrentPage: 1,
      coursewarePageSize: 10,
      coursewareTotal: 0,
      selectedCourseware: null,
      participantsDialogVisible: false,
      safetyAdministratorDialogVisible: false,
      examinerDialogVisible: false,
      instructorDialogVisible: false,
      classroomDialogVisible: false,
      selectedSafetyAdministrator: null,
      selectedSafetyAdministratorList: [],
      selectedExaminers: [],
      selectedInstructors: [],
      selectedClassroom: null,
      classroomSearchForm: {
        name: ''
      },
      classroomCurrentPage: 1,
      classroomPageSize: 10,
      classroomTotal: 0,
      employeeSearchForm: {
        name: '',
        phone: ''
      },
      employeeCurrentPage: 1,
      employeePageSize: 10,
      employeeTotal: 0,
      selectedParticipants: [],
      selectAll: false,
      participantsText: '',
      departments: [
        {
          ma_depart_id: '',
          ma_position_id: '',
          is_main: true
        }
      ],
      main_department_index: 0
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.loadCompanies();
    this.getDepartmentList();
    this.getPositionList();
    this.loadEmployees();
    // this.loadClassrooms();
    this.loadCourseware();
  },
  props: ["open_add"],
  methods: {

    loadCompanies() {
      let self = this;
      Ma_companyApi.list({}, true)
          .then(data => {
            if (data.code == 1) {
              self.companyList = data.data.list.data;
            }
          })
          .catch(error => {
          });
    },

    getDepartmentList() {
      let self = this;
      AfuncApi.call({
        model: 'ma_depart',
        action: 'index',
        page: 1,
        list_rows: 1000,
        is_delete: 0
      }).then(data => {
        if (data.code == 1) {
          self.departmentList = data.data.list.data || [];
        }
      }).catch(error => {
        console.error('加载部门列表失败:', error);
      });
    },

    getPositionList() {
      let self = this;
      AfuncApi.call({
        model: 'ma_position',
        action: 'index',
        page: 1,
        list_rows: 1000
      }).then(data => {
        if (data.code == 1) {
          self.positionList = data.data.list.data || [];
        }
      }).catch(error => {
        console.error('加载岗位列表失败:', error);
      });
    },

    getPositionOptions(departId) {
      if (!departId) return [];
      return this.positionList.filter(position => position.ma_depart_id == departId);
    },

    handleDepartmentSelect(index, departId) {
      this.departments[index].ma_position_id = '';
    },

    addDepartment() {
      this.departments.push({
        ma_depart_id: '',
        ma_position_id: '',
        is_main: true
      });
    },

    removeDepartment(index) {
      this.departments.splice(index, 1);
    },

    loadEmployees() {
      let self = this;
      AfuncApi.call({
        model: 'ma_yg',
        action: 'getList',
        page: self.employeeCurrentPage,
        list_rows: self.employeePageSize,
        ...self.employeeSearchForm
      }).then(data => {
        if (data.code == 1) {
          self.employeeList = data.data.list.data || [];
          self.employeeTotal = data.data.list.total || 0;
        }
      }).catch(error => {
        console.error('加载员工列表失败:', error);
      });
    },

    // 无教室逻辑已注释
    // loadClassrooms() {
    //   let self = this;
    //   Ma_classrm_mgmtApi.list({ page: self.classroomCurrentPage, list_rows: self.classroomPageSize, ...self.classroomSearchForm }, true)
    //     .then(data => { if (data.code == 1) { self.classroomList = data.data.list.data || []; self.classroomTotal = data.data.list.total || 0; } })
    //     .catch(error => { console.error('加载课堂列表失败:', error); });
    // },

    loadCourseware() {
      let self = this;
      Ma_classrm_mgmtApi.list({
        page: self.coursewareCurrentPage,
        list_rows: self.coursewarePageSize,
        search: self.coursewareSearchForm.search,
        orgName: self.coursewareSearchForm.orgName,
        classStatus: self.coursewareSearchForm.classStatus,
        applicableScope: self.coursewareSearchForm.applicableScope
      }, true).then(data => {
        if (data.code == 1) {
          self.coursewareList = data.data.list.data || [];
          self.coursewareTotal = data.data.list.total || 0;
        }
      }).catch(err => { console.error('加载课堂列表失败:', err); });
    },

    openCoursewareDialog() {
      this.coursewareDialogVisible = true;
      this.selectedCourseware = null;
      this.loadCourseware();
    },

    searchCourseware() {
      this.coursewareCurrentPage = 1;
      this.loadCourseware();
    },

    resetCoursewareSearch() {
      this.coursewareSearchForm = { search: '', orgName: '', classStatus: '', applicableScope: '' };
      this.coursewareCurrentPage = 1;
      this.loadCourseware();
    },

    selectCourseware(row) {
      this.selectedCourseware = row;
    },

    confirmCourseware() {
      if (this.selectedCourseware) {
        this.form.training_course = this.selectedCourseware.ma_classrm_mgmt_id;
        this.form.training_course_name = this.selectedCourseware.name;
        this.coursewareDialogVisible = false;
      } else {
        this.$message.warning('请选择一个课堂');
      }
    },

    handleCoursewareSizeChange(size) {
      this.coursewarePageSize = size;
      this.loadCourseware();
    },

    handleCoursewareCurrentChange(page) {
      this.coursewareCurrentPage = page;
      this.loadCourseware();
    },

    openSafetyAdministratorDialog() {
      this.safetyAdministratorDialogVisible = true;
      this.selectedSafetyAdministratorList = [];
      this.loadEmployees();
      this.$nextTick(() => {
        this.$refs.safetyAdminTable && this.$refs.safetyAdminTable.clearSelection();
      });
    },

    handleSafetyAdministratorSelectionChange(selection) {
      this.selectedSafetyAdministratorList = selection || [];
    },

    confirmSafetyAdministrator() {
      if (this.selectedSafetyAdministratorList && this.selectedSafetyAdministratorList.length > 0) {
        const row = this.selectedSafetyAdministratorList[0];
        this.form.safety_administrator = row.ma_employee_id;
        this.form.safety_administrator_name = row.name;
        this.safetyAdministratorDialogVisible = false;
      } else {
        this.$message.warning('请选择一个安全管理员');
      }
    },

    openExaminerDialog() {
      this.examinerDialogVisible = true;
      this.loadEmployees();
    },

    handleExaminerSelectionChange(selection) {
      this.selectedExaminers = selection;
    },

    confirmExaminer() {
      if (this.selectedExaminers && this.selectedExaminers.length > 0) {
        const ids = this.selectedExaminers.map(item => item.ma_employee_id);
        const names = this.selectedExaminers.map(item => item.name);
        this.form.examiner = ids;
        this.form.examiner_text = names.join(', ');
        this.examinerDialogVisible = false;
      } else {
        this.$message.warning('请选择考核人员');
      }
    },

    openInstructorDialog() {
      this.instructorDialogVisible = true;
      this.loadEmployees();
    },

    handleInstructorSelectionChange(selection) {
      this.selectedInstructors = selection;
    },

    confirmInstructor() {
      if (this.selectedInstructors && this.selectedInstructors.length > 0) {
        const ids = this.selectedInstructors.map(item => item.ma_employee_id);
        const names = this.selectedInstructors.map(item => item.name);
        this.form.instructor = ids;
        this.form.instructor_text = names.join(', ');
        this.instructorDialogVisible = false;
      } else {
        this.$message.warning('请选择授课人');
      }
    },

    // 无教室逻辑已注释
    // openClassroomDialog() { this.classroomDialogVisible = true; this.loadClassrooms(); },
    // searchClassroom() { this.classroomCurrentPage = 1; this.loadClassrooms(); },
    // resetClassroomSearch() { this.classroomSearchForm = { name: '' }; this.classroomCurrentPage = 1; this.loadClassrooms(); },
    // selectClassroom(row) { this.selectedClassroom = row; },
    // confirmClassroom() {
    //   if (this.selectedClassroom) {
    //     this.form.training_room = this.selectedClassroom.ma_classrm_mgmt_id;
    //     this.form.training_room_name = this.selectedClassroom.name;
    //     this.classroomDialogVisible = false;
    //   } else { this.$message.warning('请选择一个培训教室'); }
    // },
    // handleClassroomSizeChange(size) { this.classroomPageSize = size; this.loadClassrooms(); },
    // handleClassroomCurrentChange(page) { this.classroomCurrentPage = page; this.loadClassrooms(); },

    updateParticipantsText() {
      if (this.form.participants && Array.isArray(this.form.participants)) {
        const names = this.form.participants.map(id => {
          const numId = parseInt(id);
          const employee = this.employeeList.find(emp => emp.ma_employee_id === numId || emp.ma_employee_id == id);
          return employee ? employee.name : id;
        });
        this.participantsText = names.join(', ');
      }
    },

    searchEmployees() {
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },

    resetEmployeeSearch() {
      this.employeeSearchForm = {
        name: '',
        phone: ''
      };
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },

    openParticipantsDialog() {
      this.participantsDialogVisible = true;
      this.employeeCurrentPage = 1;
      this.loadEmployees();
    },

    handleSelectionChange(selection) {
      this.selectedParticipants = selection;
      this.selectAll = selection.length === this.employeeList.length && this.employeeList.length > 0;
    },

    handleSelectAll(val) {
      if (val) {
        this.$refs.employeeTable.toggleAllSelection();
      } else {
        this.$refs.employeeTable.clearSelection();
      }
    },

    handleEmployeeSizeChange(size) {
      this.employeePageSize = size;
      this.loadEmployees();
    },

    handleEmployeeCurrentChange(current) {
      this.employeeCurrentPage = current;
      this.loadEmployees();
    },

    confirmParticipants() {
      const names = this.selectedParticipants.map(item => item.name);
      const ids = this.selectedParticipants.map(item => item.ma_employee_id);
      this.form.participants = ids;
      this.participantsText = names.join(', ');
      this.participantsDialogVisible = false;
    },

    chooseCategory(){
      this.iscategorya = true;
    },

    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    returnProductImgsFunc(e) {
      let self = this;
      if (e != null && e.length > 0) {
        if (this.code === 'document') {
          e.forEach(element => {
            if (element.file_path) {
              self.form.documents.push(element.file_path);
            }
          });
        } else if (this.code === 'image') {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            if (imgExpt.includes(ext)) {
              self.form.images.push(element.file_path);
            } else {
              self.$message.error("图片类型有误,请选择正确的图片格式");
            }
          });
        }
      }
      this.isProductUpload = false;
    },

    getFileName(path) {
      if (!path) return '';
      const parts = path.split('/');
      return parts[parts.length - 1];
    },

    deleteDocument(index) {
      this.form.documents.splice(index, 1);
    },

    deleteImage(index) {
      this.form.images.splice(index, 1);
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.departments = self.departments;
      self.$refs.form.validate(valid => {
        if (valid) {
          if (form.departments.some(dept => !dept.ma_depart_id || !dept.ma_position_id)) {
            self.$message({
              message: '请完善部门岗位信息',
              type: 'error'
            });
            return;
          }
          if (form.plan_mode && form.plan_mode !== '3') {
            if (!form.safety_administrator) {
              self.$message({
                message: '请选择安全管理员',
                type: 'error'
              });
              return;
            }
            if (!form.examiner || form.examiner.length === 0) {
              self.$message({
                message: '请选择考核人员',
                type: 'error'
              });
              return;
            }
            if (!form.instructor || form.instructor.length === 0) {
              self.$message({
                message: '请选择授课人',
                type: 'error'
              });
              return;
            }
            if (!form.study_hours) {
              self.$message({
                message: '请输入学时',
                type: 'error'
              });
              return;
            }
            if (!form.training_course) {
              self.$message({
                message: '请选择课堂',
                type: 'error'
              });
              return;
            }
            // if (!form.training_room) {
            //   self.$message({
            //     message: '请输入培训教室',
            //     type: 'error'
            //   });
            //   return;
            // }
          }
          self.loading = true;
          Ma_safety_trainingApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.participants-dialog {
  padding: 10px 0;
}

.mb10 {
  margin-bottom: 10px;
}

.mt20 {
  margin-top: 20px;
}

.ml10 {
  margin-left: 10px;
}

.text-center {
  text-align: center;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .item .file-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.draggable-list .item .file-item i {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 10px;
}

.draggable-list .item .file-item span {
  font-size: 12px;
  color: #606266;
  text-align: center;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_safety_training/index/part/add.vue